import { TID } from '@/constants/testIds';
import { STATS } from '@/constants/content';

const TID_MAP = {
    experience: TID.metricsExperience,
    clients: TID.metricsClients,
    advisors: TID.metricsAdvisors,
    trust: TID.metricsTrust,
};

export default function TrustMetrics() {
    return (
        <section className="relative -mt-2">
            <div className="container-wl">
                <div className="bg-navy text-white rounded-xl shadow-hover overflow-hidden">
                    <div className="grid grid-cols-2 lg:grid-cols-4 divide-y lg:divide-y-0 lg:divide-x divide-white/10">
                        {STATS.map((s, i) => (
                            <div
                                key={s.id}
                                data-testid={TID_MAP[s.id]}
                                className="p-8 lg:p-10 text-center group hover:bg-white/[0.03] transition-colors"
                                style={{ animationDelay: `${i * 80}ms` }}
                            >
                                <div className="font-display-bold text-gold text-5xl lg:text-6xl leading-none">
                                    {s.value}
                                </div>
                                <div className="mt-3 text-[11px] uppercase tracking-widest2 text-white/70">
                                    {s.label}
                                </div>
                                <div className="mx-auto mt-4 w-8 h-px bg-gold/60 group-hover:w-16 transition-all duration-500" />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
